import styles from './Promo.module.css'
import common from '../../common.module.scss';
import React, {useContext, useEffect, useState} from "react";
import Pagination from "@/pages/adminPanel/Components/pagination.jsx";
import {deletePromo, getCodes, updateActive} from "@/pages/adminPanel/Components/promo/api/promoApi.js";
import {toast} from "react-toastify";
import {EmployeeContext} from "@/pages/adminPanel/context/EmployeeContext.jsx";
import ConfirmDeleteModal from "@/pages/adminPanel/Components/ConfirmDeleteModal.jsx";
import {useNavigate} from "react-router-dom";


export default function AdminPromo () {

    const navigate = useNavigate();

    const [promoCodes, setPromoCodes] = useState([]);
    const [page, setPage] = useState(0);
    const [totalPages, setTotalPages] = useState(1);

    const [toDelete,   setToDelete]   = useState(null);

    const { employee } = useContext(EmployeeContext);
    const role = employee?.role;

    useEffect(() => {
        fetchData()
    }, [page]);

    const fetchData = async () => {
        try {
            const params = {
                page,
                size: 12
            }

            const res = await getCodes(params);
            const data = res.data;

            setPromoCodes(data.content);
            setTotalPages(data.totalPages);
        }catch(err) {
            console.error(err);
        }

    }

    const handlePageChange = (newPage) => {
        if (newPage >= 0 && newPage < totalPages) {
            setPage(newPage);
        }
    };

    const toggleSwitch = async (id) => {
        const promoCode = promoCodes.find(s => s.id === id);
        const newState = !promoCode.isActive;
        try {
            await updateActive(id)
            setPromoCodes(prev => prev.map(s => s.id === id ? { ...s, isActive: newState } : s));
        } catch (e) {
            const errorMessage = e?.response?.data?.message || 'Ошибка при обновлении состояния промокода';
            toast.error(errorMessage);
        }
    };

    const handleDelete = async () => {
        try {
            await deletePromo(toDelete.id)
            setPromoCodes(prev => prev.filter(g => g.id !== toDelete.id));
            window.location.reload();
        } catch (e) {
            const errorMessage = e?.response?.data?.message || 'Ошибка удаления';
            toast.error(errorMessage);
            console.error('Ошибка удаления', e);
        } finally {
            setToDelete(null);
        }
    };

    return (
        <div className={common.container}>
            <button
                className="service-btn btn-primary"
                onClick={() => {navigate("/admin/promo/create")}}
            >
                Создать промокод
            </button>
            <>
                <table className={`table ${common.table} mt-5 ${styles.table}`}>
                    <thead className={common.tableHeader}>
                        <tr>
                            <th>ID</th>
                            <th>Название</th>
                            <th>Размер скидки</th>
                            <th>Промокод</th>
                            <th>кол-во<br/>применений</th>
                            <th>Состояние</th>
                            {role !== "MASTER" && role !== "ADMIN" && (
                                <>
                                    <th></th>
                                    <th></th>
                                </>
                            )}
                        </tr>
                    </thead>
                    <tbody>
                    {
                        promoCodes.map((promo, index) => (
                            <tr className={index % 2 === 1 ? common.altRow : ''}>
                                <td>{promo.id}</td>
                                <td>{promo.name}</td>
                                <td>{promo.discountPercent}%</td>
                                <td>{promo.code}</td>
                                <td>{promo.countUse}</td>
                                <td>
                                    <div className="form-check form-switch">
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            checked={promo.isActive}
                                            onChange={() => {toggleSwitch(promo.id)}}
                                        />
                                    </div>
                                </td>
                                {role !== "ADMIN" && role !== "MASTER" && (<>
                                    <td>
                                            <span
                                                className={`btn-word black btn-link p-0 ${common.editBtn}`}
                                                onClick={() => {navigate(`/admin/promo/edit/${promo.id}`)}}
                                            >
                                                Редактировать
                                            </span>
                                    </td>

                                    <td>
                                        <span
                                            className="btn-word black btn-link text-danger p-0"
                                            onClick={() => {setToDelete(promo)}}
                                        >
                                            Удалить
                                        </span>
                                    </td>
                                </>
                                    )}
                            </tr>
                        ))
                    }
                    </tbody>
                </table>

                <Pagination page={page} totalPages={totalPages} onPageChange={handlePageChange} />
            </>

            {toDelete && (
                <ConfirmDeleteModal
                    roomName={toDelete.title}
                    onConfirm={handleDelete}
                    onCancel={() => setToDelete(null)}
                />
            )}
        </div>
    )
}